import React from 'react';
import PropTypes from 'prop-types';

import Note from '../../note';
import FieldGuide from './common/fieldGuide';
import { fieldYesToAllAdvisories } from '../../utils/constant';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';

const FieldCheckbox = ({ data }) => {
  const {
    checked,
    name,
    label,
    value,
    onChange,
    readonly,
    tooltip,
    tooltipLong,
    toolTipRichText,
    note,
    noteType,
    note2,
    note2Type
  } = data;
  const customStyle =
    name === fieldYesToAllAdvisories
      ? {
          marginBottom: '1rem',
          paddingBottom: '1rem',
          borderBottom: '1px solid #D8D8D8',
          fontWeight: '500'
        }
      : {
          display: 'flex'
        };
  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;

  const renderNotes = (noteField, variant) => {
    return (
      noteField &&
      noteField.content && (
        <Note
          variant={variant}
          type="richText"
          options={formFieldOperationOptions(value)}
          data={noteField}
        />
      )
    );
  };

  return (
    <>
      <div style={customStyle}>
        <div key={name} style={{ display: 'flex' }}>
          <label htmlFor={name} className="input-checkbox-container">
            {label}
            <input
              type="checkbox"
              id={name}
              name={name}
              value={value}
              onChange={onChange}
              checked={checked}
              disabled={readonly}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        {tooltipMessage && (
          <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
        )}
      </div>
      {renderNotes(note, noteType)}
      {renderNotes(note2, note2Type)}
    </>
  );
};

FieldCheckbox.propTypes = {
  data: PropTypes.shape({
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    readonly: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    noteType: PropTypes.string,
    note2: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    note2Type: PropTypes.string
  }).isRequired
};

export default FieldCheckbox;
